// The interventions of phase 4 (script/personas/pilotage.md): what every one of them asks first.
// - active(): false for the visitors of the holdout (A/B surface `orchestrator`, its control): they get
//   none of the interventions, so their figures measure what all of them do together.
// - intent(): the live intent of the visit (Intent::Live, GET /api/v1/intent), fetched ahead and read
//   without waiting: an intervention never delays the page; without a score, today's behaviour. Fetched
//   for the holdout too: every exposure carries it as a covariate (trackingActions), which must not depend
//   on the arm; the interventions stay gated by active(). The holdout's own exposure waits for it (at most
//   EXPOSE_WAIT_MS, in both groups alike).
import api from '@js/actions/api';
import {trackExperimentExposure} from '@js/actions/trackingActions';

const REFRESH_MS = 2 * 60 * 1000;
const EXPOSE_WAIT_MS = 3000;

let latest = null;
let fetchedAt = 0;
let pending = null;
let exposed = false;

const Orchestrator = {
    active() {
        return window.experiments?.orchestrator !== 'control';
    },

    // The holdout decides from the first intervention the visit could get: both groups are exposed there,
    // with the live intent once fetched (its covariate), or without it after EXPOSE_WAIT_MS.
    expose() {
        if (exposed || !window.experiments?.orchestrator) {
            return;
        }

        exposed = true;
        let sent = false;
        let timer = null;
        const send = () => {
            if (!sent) {
                sent = true;
                clearTimeout(timer);
                trackExperimentExposure('orchestrator');
            }
        };
        timer = setTimeout(send, EXPOSE_WAIT_MS);
        Promise.resolve(this.refresh({early: true})).finally(send);
    },

    intent() {
        return latest;
    },

    // At most every REFRESH_MS, for every arm; the early request (the exposure's) does not count.
    refresh({early = false} = {}) {
        if (pending || Date.now() - fetchedAt < REFRESH_MS) {
            return pending;
        }

        if (!early) {
            fetchedAt = Date.now();
        }
        pending = api.get('/api/v1/intent', {}, {noCache: true, priorityLow: true, silentErrors: true, silentOffline: true})
            .then((score) => {
                if (score && typeof score.basket === 'number') {
                    latest = score;
                }
            })
            .catch(() => null)
            .finally(() => {
                pending = null;
            });

        return pending;
    },

    // Tests only.
    reset() {
        latest = null;
        fetchedAt = 0;
        pending = null;
        exposed = false;
    }
};

export default Orchestrator;
